











import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useScreenSize } from '~/diptyqueTheme/composable/useScreenSize';
import type { SeoTextBlockModel } from '~/integrations/contentful/src/types';

export default defineComponent<{
  sectionData: SeoTextBlockModel;
}>({
  name: 'SeoTextBlock',
  components: {
    VaimoTruncatedText: () => import('atoms/VaimoTruncatedText.vue')
  },
  props: {
    sectionData: {
      required: true,
      type: Object
    }
  },
  setup(props) {
    const { isDesktop } = useScreenSize();
    const linesQty = computed(() => (isDesktop.value ? 2 : 5));

    const data = computed(() => {
      return {
        text: props.sectionData?.text,
        truncate: 'by lines',
        lines: linesQty.value
      };
    });

    return {
      data
    };
  }
});
